import React from 'react';

const Logo = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="27.975px"
      height="41.038px"
      viewBox="0 0 27.975 41.038"
      enableBackground="new 0 0 27.975 41.038"
    >
      <polygon fill="#212C55" points="4.408,0.627 0.512,4.524 4.408,4.524 " />
      <g>
        <defs>
          <rect
            id="SVGID_1_"
            x="-22.725"
            y="0.363"
            width="71.591"
            height="61.134"
          />
        </defs>
        <clipPath id="SVGID_2_">
          <use href="#SVGID_1_" overflow="visible" />
        </clipPath>
        <polygon
          clipPath="url(#SVGID_2_)"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="0.2187"
          strokeMiterlimit="10"
          points="
        4.408,0.627 0.512,4.524 4.408,4.524 	"
        />
      </g>
      <polygon fill="#253787" points="0.512,4.524 0.512,8.42 4.408,4.524 " />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,4.524 0.512,8.42 4.408,4.524 
      "
      />
      <polygon fill="#105471" points="0.512,8.42 4.408,8.42 4.408,4.524 " />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,8.42 4.408,8.42 4.408,4.524 "
      />
      <polygon fill="#1581AC" points="0.512,8.42 4.408,12.317 4.408,8.42 " />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,8.42 4.408,12.317 4.408,8.42 
      "
      />
      <polygon fill="#1294C6" points="0.512,12.317 4.408,12.317 0.512,8.42 " />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,12.317 4.408,12.317 0.512,8.42 
      "
      />
      <polygon
        fill="#69BD97"
        points="0.512,12.317 0.512,16.214 4.408,12.317 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,12.317 0.512,16.214 
      4.408,12.317 "
      />
      <polygon
        fill="#45B385"
        points="0.512,16.214 4.408,16.214 4.408,12.317 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,16.214 4.408,16.214 
      4.408,12.317 "
      />
      <polygon
        fill="#67B54B"
        points="0.512,16.214 4.408,20.111 4.408,16.214 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,16.214 4.408,20.111 
      4.408,16.214 "
      />
      <polygon
        fill="#92C136"
        points="0.512,20.111 4.408,20.111 0.512,16.214 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,20.111 4.408,20.111 
      0.512,16.214 "
      />
      <polygon
        fill="#BBD03D"
        points="0.512,20.111 0.512,24.008 4.408,20.111 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,20.111 0.512,24.008 
      4.408,20.111 "
      />
      <polygon
        fill="#9FB044"
        points="0.512,24.008 4.408,24.008 4.408,20.111 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,24.008 4.408,24.008 
      4.408,20.111 "
      />
      <polygon
        fill="#61B147"
        points="0.512,24.008 4.408,27.904 4.408,24.008 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,24.008 4.408,27.904 
      4.408,24.008 "
      />
      <polygon
        fill="#2C7331"
        points="0.512,27.904 4.408,27.904 0.512,24.008 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,27.904 4.408,27.904 
      0.512,24.008 "
      />
      <polygon
        fill="#2C5224"
        points="0.512,27.904 0.512,31.801 4.408,27.904 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,27.904 0.512,31.801 
      4.408,27.904 "
      />
      <polygon
        fill="#61B147"
        points="0.512,31.801 4.408,31.801 4.408,27.904 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,31.801 4.408,31.801 
      4.408,27.904 "
      />
      <polygon
        fill="#ED6F36"
        points="0.512,35.698 4.408,35.698 0.512,31.802 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,35.698 4.408,35.698 
      0.512,31.802 "
      />
      <polygon
        fill="#7ABC61"
        points="0.512,31.801 4.408,35.698 4.408,31.801 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,31.801 4.408,35.698 
      4.408,31.801 "
      />
      <polygon
        fill="#F3AD38"
        points="0.512,35.698 4.408,39.594 4.408,35.698 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="0.512,35.698 4.408,39.594 
      4.408,35.698 "
      />
      <polygon
        fill="#F0E51C"
        points="4.408,35.698 4.408,39.594 8.305,35.698 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="4.408,35.698 4.408,39.594 
      8.305,35.698 "
      />
      <polygon
        fill="#F0E51C"
        points="4.408,39.594 8.305,39.594 8.305,35.698 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="4.408,39.594 8.305,39.594 
      8.305,35.698 "
      />
      <polygon
        fill="#FAC64A"
        points="8.305,35.698 8.305,39.594 12.202,35.698 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="8.305,35.698 8.305,39.594 
      12.202,35.698 "
      />
      <polygon
        fill="#F6BB2B"
        points="8.305,31.801 8.305,35.698 12.202,31.801 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="8.305,31.801 8.305,35.698 
      12.202,31.801 "
      />
      <polygon
        fill="#E9A90D"
        points="12.202,35.698 12.202,31.8 8.305,35.698 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="12.202,35.698 12.202,31.8 
      8.305,35.698 "
      />
      <polygon
        fill="#F59E28"
        points="8.305,31.801 12.202,31.801 8.305,27.904 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="8.305,31.801 12.202,31.801 
      8.305,27.904 "
      />
      <polygon
        fill="#ED6C36"
        points="12.202,27.904 8.305,27.904 12.202,31.801 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="12.202,27.904 8.305,27.904 
      12.202,31.801 "
      />
      <polygon
        fill="#EB5B1F"
        points="12.202,27.904 12.202,24.007 8.305,27.904 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="12.202,27.904 12.202,24.007 
      8.305,27.904 "
      />
      <polygon fill="#305798" points="4.408,0.627 4.408,4.524 8.305,0.627 " />
      <g>
        <defs>
          <rect
            id="SVGID_3_"
            x="-22.725"
            y="0.363"
            width="71.591"
            height="61.134"
          />
        </defs>
        <clipPath id="SVGID_4_">
          <use href="#SVGID_3_" overflow="visible" />
        </clipPath>
        <polygon
          clipPath="url(#SVGID_4_)"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="0.2187"
          strokeMiterlimit="10"
          points="
        4.408,0.627 4.408,4.524 8.305,0.627 	"
        />
      </g>
      <polygon fill="#4470B6" points="8.305,0.627 4.408,4.524 8.305,4.524 " />
      <g>
        <defs>
          <rect
            id="SVGID_5_"
            x="-22.725"
            y="0.363"
            width="71.591"
            height="61.134"
          />
        </defs>
        <clipPath id="SVGID_6_">
          <use href="#SVGID_5_" overflow="visible" />
        </clipPath>
        <polygon
          clipPath="url(#SVGID_6_)"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="0.2187"
          strokeMiterlimit="10"
          points="
        8.305,0.627 4.408,4.524 8.305,4.524 	"
        />
      </g>
      <polygon fill="#3199A5" points="8.305,0.627 8.305,4.524 12.202,4.524 " />
      <g>
        <defs>
          <rect
            id="SVGID_7_"
            x="-22.725"
            y="0.363"
            width="71.591"
            height="61.134"
          />
        </defs>
        <clipPath id="SVGID_8_">
          <use href="#SVGID_7_" overflow="visible" />
        </clipPath>
        <polygon
          clipPath="url(#SVGID_8_)"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="0.2187"
          strokeMiterlimit="10"
          points="
        8.305,0.627 8.305,4.524 12.202,4.524 	"
        />
      </g>
      <polygon fill="#27ADE4" points="8.305,0.627 12.202,4.524 12.202,0.627 " />
      <g>
        <defs>
          <rect
            id="SVGID_9_"
            x="-22.725"
            y="0.363"
            width="71.591"
            height="61.134"
          />
        </defs>
        <clipPath id="SVGID_10_">
          <use href="#SVGID_9_" overflow="visible" />
        </clipPath>
        <polygon
          clipPath="url(#SVGID_10_)"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="0.2187"
          strokeMiterlimit="10"
          points="
        8.305,0.627 12.202,4.524 12.202,0.627 	"
        />
      </g>
      <polygon
        fill="#C5D430"
        points="12.202,0.627 12.202,4.524 16.099,0.627 "
      />
      <g>
        <defs>
          <rect
            id="SVGID_11_"
            x="-22.725"
            y="0.363"
            width="71.591"
            height="61.134"
          />
        </defs>
        <clipPath id="SVGID_12_">
          <use href="#SVGID_11_" overflow="visible" />
        </clipPath>
        <polygon
          clipPath="url(#SVGID_12_)"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="0.2187"
          strokeMiterlimit="10"
          points="
        12.202,0.627 12.202,4.524 16.099,0.627 	"
        />
      </g>
      <polygon
        fill="#A8D08D"
        points="16.099,0.627 12.202,4.524 16.099,4.524 "
      />
      <g>
        <defs>
          <rect
            id="SVGID_13_"
            x="-22.725"
            y="0.363"
            width="71.591"
            height="61.134"
          />
        </defs>
        <clipPath id="SVGID_14_">
          <use href="#SVGID_13_" overflow="visible" />
        </clipPath>
        <polygon
          clipPath="url(#SVGID_14_)"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="0.2187"
          strokeMiterlimit="10"
          points="
        16.099,0.627 12.202,4.524 16.099,4.524 	"
        />
      </g>
      <polygon
        fill="#71AE47"
        points="16.099,0.627 16.099,4.524 19.996,4.524 "
      />
      <g>
        <defs>
          <rect
            id="SVGID_15_"
            x="-22.725"
            y="0.363"
            width="71.591"
            height="61.134"
          />
        </defs>
        <clipPath id="SVGID_16_">
          <use href="#SVGID_15_" overflow="visible" />
        </clipPath>
        <polygon
          clipPath="url(#SVGID_16_)"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="0.2187"
          strokeMiterlimit="10"
          points="
        16.099,0.627 16.099,4.524 19.996,4.524 	"
        />
      </g>
      <polygon
        fill="#548235"
        points="16.099,0.627 19.996,4.524 19.996,0.627 "
      />
      <g>
        <defs>
          <rect
            id="SVGID_17_"
            x="-22.725"
            y="0.363"
            width="71.591"
            height="61.134"
          />
        </defs>
        <clipPath id="SVGID_18_">
          <use href="#SVGID_17_" overflow="visible" />
        </clipPath>
        <polygon
          clipPath="url(#SVGID_18_)"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="0.2187"
          strokeMiterlimit="10"
          points="
        16.099,0.627 19.996,4.524 19.996,0.627 	"
        />
      </g>
      <polygon
        fill="#376F35"
        points="19.996,0.627 19.996,4.524 23.892,0.627 "
      />
      <g>
        <defs>
          <rect
            id="SVGID_19_"
            x="-22.725"
            y="0.363"
            width="71.591"
            height="61.134"
          />
        </defs>
        <clipPath id="SVGID_20_">
          <use href="#SVGID_19_" overflow="visible" />
        </clipPath>
        <polygon
          clipPath="url(#SVGID_20_)"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="0.2187"
          strokeMiterlimit="10"
          points="
        19.996,0.627 19.996,4.524 23.892,0.627 	"
        />
      </g>
      <polygon
        fill="#71AE47"
        points="23.893,0.627 19.996,4.524 23.893,4.524 "
      />
      <g>
        <defs>
          <rect
            id="SVGID_21_"
            x="-22.725"
            y="0.363"
            width="71.591"
            height="61.134"
          />
        </defs>
        <clipPath id="SVGID_22_">
          <use href="#SVGID_21_" overflow="visible" />
        </clipPath>
        <polygon
          clipPath="url(#SVGID_22_)"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="0.2187"
          strokeMiterlimit="10"
          points="
        23.893,0.627 19.996,4.524 23.893,4.524 	"
        />
      </g>
      <polygon
        fill="#A8D08D"
        points="23.893,0.627 23.893,4.524 27.789,4.524 "
      />
      <g>
        <defs>
          <rect
            id="SVGID_23_"
            x="-22.725"
            y="0.363"
            width="71.591"
            height="61.134"
          />
        </defs>
        <clipPath id="SVGID_24_">
          <use href="#SVGID_23_" overflow="visible" />
        </clipPath>
        <polygon
          clipPath="url(#SVGID_24_)"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="0.2187"
          strokeMiterlimit="10"
          points="
        23.893,0.627 23.893,4.524 27.789,4.524 	"
        />
      </g>
      <polygon fill="#EE7E32" points="23.893,4.524 23.893,8.42 27.789,4.524 " />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="23.893,4.524 23.893,8.42 
      27.789,4.524 "
      />
      <polygon fill="#F4B184" points="23.893,8.42 27.789,8.42 27.789,4.524 " />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="23.893,8.42 27.789,8.42 27.789,4.524 
      "
      />
      <polygon fill="#E99735" points="23.893,8.42 23.893,12.317 27.789,8.42 " />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="23.893,8.42 23.893,12.317 
      27.789,8.42 "
      />
      <polygon
        fill="#E99735"
        points="19.996,12.317 23.893,12.317 19.996,8.42 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="19.996,12.317 23.893,12.317 
      19.996,8.42 "
      />
      <polygon fill="#F28A1C" points="23.893,8.42 19.996,8.42 23.893,12.317 " />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="23.893,8.42 19.996,8.42 
      23.893,12.317 "
      />
      <polygon fill="#E73B1A" points="16.099,8.42 16.099,12.317 19.996,8.42 " />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="16.099,8.42 16.099,12.317 
      19.996,8.42 "
      />
      <polygon
        fill="#E99735"
        points="19.996,12.317 19.996,8.42 16.099,12.317 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="19.996,12.317 19.996,8.42 
      16.099,12.317 "
      />
      <polygon
        fill="#C81517"
        points="12.202,12.317 16.099,12.317 12.202,8.42 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="12.202,12.317 16.099,12.317 
      12.202,8.42 "
      />
      <polygon fill="#E73938" points="16.099,8.42 12.202,8.42 16.099,12.317 " />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="16.099,8.42 12.202,8.42 
      16.099,12.317 "
      />
      <polygon
        fill="#6D2477"
        points="19.996,20.111 23.893,20.111 19.996,16.214 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="19.996,20.111 23.893,20.111 
      19.996,16.214 "
      />
      <polygon
        fill="#3C1A44"
        points="19.996,24.007 23.893,24.007 19.996,20.111 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="19.996,24.007 23.893,24.007 
      19.996,20.111 "
      />
      <polygon
        fill="#8C4292"
        points="23.893,20.111 19.996,20.111 23.893,24.008 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="23.893,20.111 19.996,20.111 
      23.893,24.008 "
      />
      <polygon
        fill="#57225F"
        points="16.099,16.214 16.099,20.111 19.996,16.214 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="16.099,16.214 16.099,20.111 
      19.996,16.214 "
      />
      <polygon
        fill="#8C4292"
        points="19.996,20.111 19.996,16.214 16.099,20.111 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="19.996,20.111 19.996,16.214 
      16.099,20.111 "
      />
      <polygon
        fill="#BD4271"
        points="16.099,16.214 12.202,16.214 16.099,20.111 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="16.099,16.214 12.202,16.214 
      16.099,20.111 "
      />
      <polygon
        fill="#934996"
        points="12.202,20.111 16.099,20.111 12.202,16.214 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="12.202,20.111 16.099,20.111 
      12.202,16.214 "
      />
      <polygon
        fill="#B87BB3"
        points="12.202,16.214 8.305,16.214 12.202,20.111 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="12.202,16.214 8.305,16.214 
      12.202,20.111 "
      />
      <polygon
        fill="#673A8F"
        points="8.305,12.317 8.305,16.214 12.202,12.317 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="8.305,12.317 8.305,16.214 
      12.202,12.317 "
      />
      <polygon
        fill="#934996"
        points="12.202,16.214 12.202,12.317 8.305,16.214 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="12.202,16.214 12.202,12.317 
      8.305,16.214 "
      />
      <polygon
        fill="#651222"
        points="19.996,24.007 19.996,27.905 23.893,24.007 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="19.996,24.007 19.996,27.905 
      23.893,24.007 "
      />
      <polygon
        fill="#B7181C"
        points="19.996,27.904 19.996,24.007 16.099,27.904 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="19.996,27.904 19.996,24.007 
      16.099,27.904 "
      />
      <polygon
        fill="#E41A24"
        points="16.099,24.007 16.099,27.905 19.996,24.007 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="16.099,24.007 16.099,27.905 
      19.996,24.007 "
      />
      <polygon
        fill="#E73638"
        points="16.099,24.007 12.202,24.007 16.099,27.905 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="16.099,24.007 12.202,24.007 
      16.099,27.905 "
      />
      <polygon
        fill="#EC6531"
        points="12.202,27.904 16.099,27.904 12.202,24.007 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="12.202,27.904 16.099,27.904 
      12.202,24.007 "
      />
      <polygon
        fill="#B7181D"
        points="12.202,12.317 12.202,8.42 8.305,12.317 "
      />
      <polygon
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="0.2187"
        strokeMiterlimit="10"
        points="12.202,12.317 12.202,8.42 
      8.305,12.317 "
      />
    </svg>
  );
};

export default Logo;
